class DocumentsController {
    init() {

    }

    index() {
        // Table sorting and pagination now handled by Stimulus table controller
    }

	edit() {

    }
}

window.BC = window.BC || {};
window.BC.documents = new DocumentsController();